export default __webpack_public_path__ + "static/media/flag-hu.061a833b.svg";